@import '../../sass/components/calendar-vertical';
